<div class="card">
    <div class="card-body">
        <h5 class="card-title">Tìm kiếm chi nhánh</h5>
        <form [formGroup]="searchForm">
            <div class="row">
                <div class="col">
                    <app-input-text label="Mã" placeholder="Nhập mã" [formGroup]="searchForm" formControlName="codeLike"></app-input-text>
                </div>
                <div class="col">
                    <app-input-text label="Tên" placeholder="Nhập tên" [formGroup]="searchForm" formControlName="nameLike"></app-input-text>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <app-input-select label="Trạng thái" placeholder="Chọn trạng thái" [formGroup]="searchForm" formControlName="status" [optionList]="branchStatusOptionList"></app-input-select>
                </div>
                <div class="col">
                </div>
            </div>
        </form>
        <div class="d-flex justify-content-center">
        <div class="btn-group">
            <button type="button" class="btn btn-primary" (click)="searchBranch()" [disabled]="loading"><span *ngIf="loading"  class="spinner-border spinner-border-sm"></span>Tìm kiếm</button>
        </div>
    </div>
    </div>
</div>
<div class="card">
    <div class="card-body">
        <h5 class="card-title">Kết quả tìm kiếm</h5>
        <div class="alert alert-danger" role="alert" *ngIf="error">
          {{error}}
        </div>
        <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Mã</th>
                    <th scope="col">Tên</th>
                    <th scope="col">Trạng thái</th>
                    <th scope="col">
                        <div class="btn-group">
                            <button type="button" class="btn btn-primary" *ngIf="hasEditPerm" (click)="insertBranch()">Thêm</button>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody *ngIf="sysBranchList && !loading">
                <tr *ngFor="let sysBranch of sysBranchList;index as sysBranchIndex">
                    <td scope="col">{{(sysBranchPagination.currentPage-1)*sysBranchPagination.pageSize + sysBranchIndex+1}}</td>
                    <td scope="col">{{sysBranch.code}}</td>
                    <td scope="col">{{sysBranch.name}}</td>
                    <td scope="col">{{branchStatusOptionMap[sysBranch.status]}}</td>
                    <td scope="col">
                        <div class="btn-group">
                            <button type="button" class="btn btn-info" (click)="viewBranch(sysBranch)">Xem</button>
                            <button type="button" class="btn btn-primary" *ngIf="hasEditPerm" (click)="editBranch(sysBranch)">Sửa</button>
                            <button type="button" class="btn btn-danger"  *ngIf="hasEditPerm" (click)="deleteBranch(sysBranch)">Xóa</button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
        <div class="d-flex justify-content-between align-items-center" *ngIf="sysBranchPagination.pageCount>1 && !loading">
            <nav>
                <ul class="pagination">
                    <li class="page-item" [ngClass]="{'disabled':sysBranchPagination.currentPage == 1}">
                      <a class="page-link" (click)="sysBranchPageChange(sysBranchPagination.currentPage-1)">Trước</a>
                    </li>
                    <li class="page-item" *ngIf="sysBranchPagination.currentPage > 3">
                      <a class="page-link" (click)="sysBranchPageChange(1)">1</a>
                    </li>
                  <li class="page-item disabled" *ngIf="sysBranchPagination.currentPage > 3">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngFor="let page of sysBranchPagination.pageList"  [ngClass]="{'active':sysBranchPagination.currentPage == page}">
                    <a class="page-link" (click)="sysBranchPageChange(page)">{{page}}</a>
                  </li>
                  <li class="page-item disabled" *ngIf="sysBranchPagination.currentPage < sysBranchPagination.pageCount - 2">
                    <a class="page-link" >...</a>
                  </li>
                  <li class="page-item" *ngIf="sysBranchPagination.currentPage < sysBranchPagination.pageCount - 2">
                    <a class="page-link" (click)="sysBranchPageChange(sysBranchPagination.pageCount)">{{sysBranchPagination.pageCount}}</a>
                  </li>
                  <li class="page-item" [ngClass]="{'disabled':sysBranchPagination.currentPage == sysBranchPagination.pageCount}">
                    <a class="page-link"  (click)="sysBranchPageChange(sysBranchPagination.currentPage+1)">Sau</a>
                  </li>
                </ul>
              </nav>
        </div>
    </div>
</div>

